import React from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import AccountManagement from './components/AccountManagement';
import Trading from './components/Trading';
import Reports from './components/Reports';
import './App.css';

function App() {
  return (
    <Container className='mt-4'>
      <h1 className='text-center'>Trading Simulation Platform</h1>
      <Tabs defaultActiveKey='account' id='trading-tabs' className='mb-3'>
        <Tab eventKey='account' title='Account Management'>
          <AccountManagement />
        </Tab>
        <Tab eventKey='trading' title='Trading'>
          <Trading />
        </Tab>
        <Tab eventKey='reports' title='Reports'>
          <Reports />
        </Tab>
      </Tabs>
    </Container>
  );
}

export default App;
